import {
    GetDeliveryPointsByTokenLoading,
    GetDeliveryPointsByTokenSuccess,
    GetDeliveryPointsByTokenReject,
    GetDeliveryPointsByTokenRequest
} from "../../actions/home/GetDeliveryPointsByToken";

export const GetDeliveryPointsByToken = (formData) => async (dispatch, getState) => {
    dispatch(GetDeliveryPointsByTokenLoading());
    try {
        const { data } = await GetDeliveryPointsByTokenRequest(formData, getState);
        dispatch(GetDeliveryPointsByTokenSuccess(data))
    } catch (error) {
        dispatch(GetDeliveryPointsByTokenReject(error))
    }
    return Promise.resolve();
};
